<template>
  <div class="bg-blue-900 p-4 lg:p-12">
    <div class="max-w-7xl mx-auto">
      <div class="space-y-8">
        <BaseButton
          v-if="$membershipHasPermissionTo('edit projects')"
          tag="router-link"
          :to="{
            name: 'accounts.projects.project',
            params: {
              accountId: $route.params.accountId,
              projectId: $route.params.projectId,
            },
          }"
          primary
        >
          Back to Project
        </BaseButton>
        <div class="space-y-1">
          <span class="inline-block text-sm text-blue-400">{{ project.name }}</span>
          <h3 class="text-xl text-white font-medium">Settings</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
  },

  computed: {
    coverUrl() {
      if (this.project.media.length === 0) {
        return null;
      }

      return this.project.media[0].url || null;
    },
  },
};
</script>
